import { FTIR_SAMPLE_IDS } from "@/data/labs/ft-ir-spectroscopy-lab/sampleSpectra.js";

const SAMPLE_ID_SET = new Set(FTIR_SAMPLE_IDS);

/**
 * At least one non-baseline spectrum per unknown Sample A–E.
 * @param {Array<{ isBaseline?: boolean, sampleId?: string }>} measurements
 */
export function checkAllUnknownSamplesStep(measurements = []) {
  const covered = new Set();
  for (const m of measurements) {
    if (m.isBaseline || !m.sampleId) continue;
    if (SAMPLE_ID_SET.has(m.sampleId)) covered.add(m.sampleId);
  }
  return { satisfied: covered.size >= FTIR_SAMPLE_IDS.length };
}

function unknownSamplesExitWarning(measurements) {
  const { satisfied } = checkAllUnknownSamplesStep(measurements);
  if (satisfied) return null;
  return {
    title: "Unknown samples incomplete",
    body: `Collect at least one spectrum for each of the ${FTIR_SAMPLE_IDS.length} unknown samples (Sample A through Sample E) before leaving this step. Continue anyway?`
  };
}

/**
 * Maps lab id → passage id → (measurements) => null | { title, body }.
 */
export const STEP_EXIT_CHECKS = {
  "ft-ir-spectroscopy-lab": {
    "unknown-samples": unknownSamplesExitWarning
  }
};

/**
 * @param {{ labId: string, passageId: string, measurements: unknown[] }} args
 * @returns {{ title: string, body: string } | null}
 */
export function getExitWarning({ labId, passageId, measurements }) {
  const byPassage = STEP_EXIT_CHECKS[labId];
  if (!byPassage) return null;
  const fn = byPassage[passageId];
  if (typeof fn !== "function") return null;
  return fn(measurements ?? []);
}
